import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import './TimecardsTable.css';

/**
 * source for opening google maps:
 * https://stackoverflow.com/questions/6018060/form-google-maps-url-that-searches-for-a-specific-places-near-specific-coordinat
 * https://stackoverflow.com/a/20655050
 */
const LocationCoordinateTableCell = ({
  timecards,
  direction,
  ...props
}) => {
  const createLocationString = useCallback((latitude, longitude) => {
    if (latitude && longitude) {
      const parsedLatitude = parseFloat(latitude).toFixed(3);
      const parsedLongitude = parseFloat(longitude).toFixed(3);
      const latitudeDirection = parsedLatitude > 0 ? 'N' : 'S';
      const longitudeDirection = parsedLongitude > 0 ? 'E' : 'W';

      return `${parsedLatitude}${String.fromCharCode(176)} ${latitudeDirection} / ${parsedLongitude}${String.fromCharCode(176)} ${longitudeDirection}`;
    }

    return '';
  }, []);

  const clockLocations = useCallback(direction => timecards.map((timecard, index) => {
    const latitude = timecard[`clock_${direction}_latitude`] || '';
    const longitude = timecard[`clock_${direction}_longitude`] || '';

    return (
      <a
        className='timecards-table-employee-row-text timecards-table-employee-row-link'
        key={`${latitude}_${longitude}_${index}`}
        href={`https://www.google.com/maps?q=${latitude},${longitude}`}
        target='_blank'
        rel='noopener noreferrer'
      >
        <span>{createLocationString(latitude, longitude)}</span>
      </a>
    );
  }, [timecards]));

  return (
    <td>
      { clockLocations(direction) }
    </td>
  );
};

LocationCoordinateTableCell.propTypes = {
  timecards: PropTypes.arrayOf(PropTypes.object),
  direction: PropTypes.oneOf(['in', 'out'])
};

export default LocationCoordinateTableCell;
